import React, { Component, PureComponent } from 'react';
import TetherComponent from 'react-tether';
import './buttons.css';
import { RedLightBulb } from '../icons';

export class BackButton extends PureComponent {
    render() {
        return (
            <button className="back-button" onClick={this.props.onClick}>
                <svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 62 62">
                    <circle
                        cx="31"
                        cy="31"
                        r="30"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="1.954"
                        strokeMiterlimit="10"
                    />
                    <path
                        d="M45.9,28.8H22l8.3-6.8c0.8-0.8,1.1-2.1,0.2-3c-0.8-0.8-2.1-1.1-3-0.2l-13,10.6 c-0.4,0.2-0.6,0.8-0.6,1.5s0.2,1.3,0.8,1.7l13,10.6c0.4,0.4,0.8,0.4,1.3,0.4c0.6,0,1.3-0.2,1.7-0.8c0.8-0.8,0.6-2.3-0.2-3L22,33.1 h24c1.3,0,2.1-0.8,2.1-2.1C48.1,29.7,47,28.8,45.9,28.8L45.9,28.8z"
                        fill="#fff"
                    />
                </svg>
            </button>
        );
    }
}

export class ProTipButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
        };
    }

    createMarkup(html) {
        return { __html: html };
    }

    render() {
        return (
            <TetherComponent
                attachment="top right"
                targetAttachment="top right"
                constraints={[
                    {
                        to: 'scrollParent',
                        pin: 'true',
                    },
                ]}
            >
                <button
                    onClick={() => {
                        this.props.toggleTip(true);
                        this.setState({ isOpen: !this.state.isOpen });
                    }}
                    className="protip-button"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="69.3"
                        height="69.3"
                        viewBox="0 0 69.3 69.3"
                    >
                        <circle
                            cx="34.7"
                            cy="34.7"
                            r="33.5"
                            fill="#fff"
                            stroke="#000"
                            strokeWidth="2.337"
                            strokeMiterlimit="10"
                        />
                        <path d="M42.6,40.3c0.2-0.2,0.4-0.5,0.6-0.8c0,0,0,0,0,0c0.2-0.3,0.4-0.5,0.6-0.8c0.1-0.1,0.1-0.1,0.1-0.2c0.3-0.6,0.6-1.1,0.9-1.8 l0.1-0.3c0.1-0.2,0.1-0.3,0.2-0.5c0.1-0.3,0.1-0.5,0.2-0.8c0-0.1,0-0.2,0-0.2l0-0.1c0-0.2,0.1-0.4,0.1-0.7l0-0.3c0-0.3,0-0.6,0-1 c0-5.9-4.8-10.8-10.8-10.8S24,26.9,24,32.8c0,0.3,0,0.6,0,1l0,0.3c0,0.2,0.1,0.4,0.1,0.7l0.1,0.3c0.1,0.3,0.1,0.5,0.2,0.8 c0,0.1,0.1,0.3,0.1,0.4c0,0,0,0.1,0,0.1l0.1,0.3c0.2,0.6,0.6,1.3,0.9,1.8c0,0,0,0,0,0.1c0.2,0.3,0.4,0.6,0.6,0.9c0,0,0,0,0,0 c0.2,0.2,0.4,0.5,0.6,0.7c1.5,2.1,2.3,4.2,2.3,5.7c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2v6.2c0,0.1,0,0.3,0.1,0.4 c0.3,2.7,2.6,4.8,5.4,4.8c2.9,0,5.3-2.3,5.4-5.2c0,0,0,0,0-0.1v-6.5c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 C40.3,44.4,41.1,42.4,42.6,40.3z M28.5,39.2c0,0-0.1-0.1-0.1-0.1c-0.2-0.2-0.4-0.4-0.6-0.7c0,0,0,0,0,0c-0.2-0.2-0.3-0.5-0.5-0.7 c0,0,0,0,0,0c0,0,0,0,0,0c-0.3-0.5-0.6-1-0.8-1.5l-0.1-0.3c0-0.1-0.1-0.2-0.1-0.4c-0.1-0.2-0.1-0.4-0.2-0.6L26,34.5 c0-0.2-0.1-0.4-0.1-0.6l0-0.2c0-0.3,0-0.5,0-0.8c0-4.9,4-8.9,8.9-8.9s8.9,4,8.9,8.9c0,0.3,0,0.5,0,0.8l0,0.3c0,0.2-0.1,0.4-0.1,0.6 l0,0.3c0,0.2-0.1,0.4-0.2,0.7c0,0.1-0.1,0.3-0.1,0.4L43.1,36c-0.2,0.5-0.5,1-0.7,1.5c0,0,0,0,0,0.1c-0.2,0.2-0.3,0.5-0.5,0.7 c0,0,0,0,0,0c-0.2,0.2-0.4,0.5-0.6,0.7c-0.1,0-0.1,0.1-0.1,0.2c-1.1,1.5-2.3,3.7-2.6,5.9h-7.4c0,0,0,0-0.1,0 C30.8,42.9,29.6,40.7,28.5,39.2z M38.5,46.9v1.6h-7.3c0,0,0,0,0,0v-1.6c0,0,0,0,0,0L38.5,46.9L38.5,46.9z M31.1,51.7v-1.3 c0,0,0,0,0,0h7.3v1.3L31.1,51.7L31.1,51.7z M34.8,56c-1.6,0-3-1.1-3.4-2.5h6.9C37.8,54.9,36.4,56,34.8,56z" />
                        <path d="M14,34c0,0.5,0.4,0.9,0.9,0.9h4.9c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-4.9C14.4,33.1,14,33.5,14,34z" />
                        <path d="M14.7,23.9c-0.2,0.5,0.1,1,0.6,1.2l4.7,1.7c0.1,0,0.2,0.1,0.3,0.1c0.4,0,0.7-0.2,0.9-0.6c0.2-0.5-0.1-1-0.6-1.2l-4.7-1.7 C15.4,23.2,14.9,23.4,14.7,23.9z" />
                        <path d="M24.3,21.5c0.2,0,0.5-0.1,0.7-0.3c0.4-0.4,0.3-0.9,0-1.3l-3.5-3.5c-0.4-0.4-0.9-0.3-1.3,0c-0.4,0.4-0.3,0.9,0,1.3l3.5,3.5 C23.8,21.5,24,21.5,24.3,21.5z" />
                        <path d="M54.5,34c0-0.5-0.4-0.9-0.9-0.9h-4.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h4.9C54.1,34.9,54.5,34.5,54.5,34z" />
                        <path d="M46,43.3l4.2,2.6c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.6-0.2,0.8-0.4c0.3-0.4,0.1-1-0.3-1.3l-4.2-2.6c-0.4-0.3-1-0.1-1.3,0.3 C45.4,42.5,45.5,43,46,43.3z" />
                        <path d="M21.8,41.7l-4.2,2.6c-0.4,0.3-0.6,0.8-0.3,1.3c0.2,0.3,0.5,0.4,0.8,0.4c0.2,0,0.3,0,0.5-0.1l4.2-2.6 c0.4-0.3,0.6-0.8,0.3-1.3C22.8,41.6,22.2,41.5,21.8,41.7z" />
                        <path d="M52.7,23.4L48.1,25c-0.5,0.2-0.7,0.7-0.6,1.2c0.1,0.4,0.5,0.6,0.9,0.6c0.1,0,0.2,0,0.3-0.1l4.7-1.7 c0.5-0.2,0.7-0.7,0.6-1.2C53.7,23.4,53.2,23.2,52.7,23.4z" />
                        <path d="M48,16.5c-0.4-0.4-0.9-0.4-1.3,0L43.2,20c-0.4,0.4-0.4,0.9,0,1.3c0.2,0.2,0.4,0.3,0.7,0.3c0.2,0,0.5-0.1,0.6-0.3l3.5-3.5 C48.4,17.5,48.4,16.9,48,16.5z" />
                        <path d="M33.2,13v5.4c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9V13c0-0.5-0.4-0.9-0.9-0.9S33.2,12.5,33.2,13z" />
                    </svg>
                </button>
                {this.state.isOpen && (
                    <div className="info-panel shadowed enter">
                        <CloseButton
                            onClick={() => {
                                this.props.toggleTip(false);
                                this.setState({ isOpen: false });
                            }}
                        />
                        <RedLightBulb />
                        <h3>Safety Protip</h3>
                        <div dangerouslySetInnerHTML={this.createMarkup(this.props.data)} />
                    </div>
                )}
            </TetherComponent>
        );
    }
}

export class CloseButton extends PureComponent {
    render() {
        return (
            <button className="close-button" onClick={this.props.onClick}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30.8"
                    height="30.8"
                    viewBox="0 0 30.8 30.8"
                >
                    <circle
                        cx="15.4"
                        cy="15.4"
                        r="14.9"
                        fill="none"
                        stroke="#000"
                        strokeWidth="0.972"
                        strokeMiterlimit="10"
                    />
                    <path
                        d="M15.6,14.5l5-5.6h1.8l-5.9,6.5l6,6.7h-1.8l-5.2-5.8 l-5.2,5.8H8.7l6.1-6.7L8.9,8.9h1.8L15.6,14.5z"
                        stroke="#000"
                        strokeWidth="0.691"
                        strokeMiterlimit="10"
                    />
                </svg>
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/buttons/index.js